import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import TripListing from 'components/TripListing'
import { renderTripPageHelmet, } from 'lib/pageHelmet'

class TripListingScene extends Component {

  static propTypes = {
    tripData: PropTypes.shape({
      name: PropTypes.string,
    }),
    tripId: PropTypes.string.isRequired,
    actions: PropTypes.shape({
      navViewTripAsList: PropTypes.func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    tripData: {
      name: '',
    },
  }

  componentDidMount() {
    // hack to enable scrolling ONLY when in trip list scene
    document.body.classList.add('trip-list-scene')
  }

  componentWillUnmount() {
    // hack to enable scrolling ONLY when in trip list scene
    document.body.classList.remove('trip-list-scene')
  }

  render() {
    const { tripId, actions, tripData, } = this.props

    return (
      <div data-component="TripListingScene">
        {renderTripPageHelmet({
          tripName: tripData.name,
        })}
        <TripListing
          {...this.props}
          viewEventInfo={actions.navViewListEventInfo}
          hideEventInfo={() => {
            actions.navViewTripAsList({ tripId, })
          }}
        />
      </div>
    )
  }
}

export default TripListingScene



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripListingScene/component.js